import {Component, Inject, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {QuestionModel} from "../../../../interfaces/QuestionModel";

import {ChartConfiguration, ChartDataset, ChartType} from 'chart.js';
import {Observable, Subject, takeUntil} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {UploadFile} from "../../../../interfaces/uploadFile";
import firebase from "firebase/compat/app";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {UploadModel} from "../../../../models/UploadModel";
import {AngularFireStorage} from "@angular/fire/compat/storage";
// import {AngularFireStorage} from "@angular/fire/compat/storage";
@Component({
  selector: 'app-view-assessment',
  templateUrl: './view-assessment.component.html',
  styleUrls: ['./view-assessment.component.scss']
})
export class ViewAssessmentComponent implements OnInit, OnDestroy {
    // env = isDevMode() ? environment.testMode : environment.productionMode
    private _destroyed$ = new Subject<void>();
    totalYes?=0
  totalNo?=0
  totalSometimes?=0
  assessmentData?:QuestionModel[]
  doughnutChartType: ChartType = 'doughnut';
  env = isDevMode() ? environment.testMode : environment.productionMode
  mDocuments:UploadModel[]=[]
  mDbType: 'realtime' | 'firestore' = 'firestore';
  mStoragePath?: string = 'counselling/assessment-sessions'   //Path for Image Upload Location
  mPath = this.env.counseling;                    // Path for uploaded image url database location
  documents$: Observable<unknown | undefined>


  colors: any[] = [{backgroundColor: [ "#6114be", "#0b5ba8","#15dcdc"]}];
  chartconfigurationsArray:any[]=[]
  public doughnutChartLabels: string[] = ['Not able to Cope up', 'Able to Cope up', 'Difficulty in Coping up'];
// documents$: any[] | undefined


  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AssessmentModel,
    private readonly  mFirestore:AngularFirestore,
    private readonly mStorage:AngularFireStorage,
    private readonly _snackBar:MatSnackBar,
    private dialogRef: MatDialogRef<ViewAssessmentComponent>
  ) {
this.assessmentData =data.assessment
 // this.  getData(data.id)
    this.mStoragePath = this.mStoragePath + '/' + data.id
    this.mPath =this.env.documents+'/'+ this.mPath + '/assessmentSessions/' + data.id
    console.log(`Document will be uploaded to ${this.mStoragePath} on ${this.mDbType} in ${this.mPath} `)

    // Stamp root-level metadata so records are queryable by date & centre
    const sessionDate = data.dateOfAssessment || null;
    this.mFirestore.doc(this.mPath).set({
      date:       sessionDate,
      dateAdded:  sessionDate,
      centreCode: data.centreCode || '',
      centreName: data.centreName || '',
    }, { merge: true });

    this.documents$  = this.mFirestore.doc( this.mPath).valueChanges({idField:'id'})
    this.documents$.pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      // @ts-ignore
      this.mDocuments = res.documents as UploadModel
    })
  }

  ngOnInit(): void {
    //alert(this.assessmentData?.length)
    this.assessmentData?.forEach(it=>{
      if(it.ans=='Yes') this.totalYes!++
      else if(it.ans=='No')this.totalNo!++
      else if (it.ans=='Sometimes')this.totalSometimes!++
    })
    const doughnutChartDatasets= [
      // {data: [10, 10, 10], label:'Graph Title' ,backgroundColor: ["#fbc02d", "#00695c", "#af1111"]},
      {data: [this.totalYes!, this.totalNo, this.totalSometimes], label:'Graph Title' ,backgroundColor: [ "#af1111","#00695c","#fbc02d"]},

      // { data: [ 50, 150, 120 ], label: 'Series B' },
      // { data: [ 250, 130, 70 ], label: 'Series C' }
    ];
    // @ts-ignore
    this.chartconfigurationsArray.push(doughnutChartDatasets)

  }

  close() {
    this.dialogRef.close()
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  // private getData(id: string) {
  // this.mFirestore.collection<AssessmentModel>(this.env.assessment+'/allAssessments/assessments').doc(this.data.id).valueChanges({idField:'id'}).subscribe(res=>[
  //     this.documents$ =res?.documents
  // ])
  //
  // }
    // @needConfirmation()
    // deleteAdmissionFile(i: number, d: UploadFile, category: string) {
        // const iRef = this.mStorage.storage.refFromURL(d.fileUrl)
        // iRef.delete().then(() => {
        //     this.mFirestore.collection(this.env.assessment+'allAssessments/assessments').doc(this.data.id).update({
        //         [category]: firebase.firestore.FieldValue.arrayRemove(d)
        //     }).then(() => {
        //         this._snackBar.open('File Deleted Successfully')._dismissAfter(2000)
        //     })
        // })
        // console.log(iRef)
    // }

    trackByMethod(index: number, el: any): number {
        return el.id;
    }

    openLink(fileUrl: string) {
        window.open(fileUrl)

    }



  @needConfirmation()
  deleteAdmissionFile(i: number, d: UploadModel, category: string) {
    const iRef = this.mStorage.storage.refFromURL(d.url)
    iRef.delete().then(() => {
      this.mFirestore.doc(this.mPath).update({
        [category]: firebase.firestore.FieldValue.arrayRemove(d)
      }).then(() => {
        this._snackBar.open('File Deleted Successfully')._dismissAfter(2000)
      })
    })
    console.log(iRef)
  }
}
